import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-showOpen",
  "use": "icon-showOpen-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-showOpen\"><defs><style type=\"text/css\"></style></defs><path d=\"M703.591 511.573L383.765 831.356V639.74l128.167-128.338-128.167-127.614V191.705z\" p-id=\"8454\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol